import { render, staticRenderFns } from "./OtcSVG.vue?vue&type=template&id=063c5d14&"
import script from "./OtcSVG.vue?vue&type=script&lang=js&"
export * from "./OtcSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports